<template>
  <div
    class="row myrow content-mb-25"
    v-if="$parent.$parent.rerender && tagsLoaded"
  >
    <div class="col-xs-12 mycol content-mb-14">
      <p class="content-s-2-label">
        <label>Продукция ориентирована на экспорт:</label>
      </p>
      <select
        v-model="project.UF_IS_EXPORT_PRODUCT"
        class="sel-dropdown i-main-style i-wid-13"
        :disabled="$parent.$parent.projectDisabled"
      >
        <option value="0">Нет</option>
        <option value="1">Да</option>
      </select>
    </div>
    <div
      class="col-xs-12 mycol content-mb-14"
      v-show="project.UF_IS_EXPORT_PRODUCT == '1'"
      v-bind:class="{
        'has-error': $parent.$parent.checkErrorField(
          'PROJECTS',
          'LOGIC',
          'UF_EXPORT_COUNTRY_ID'
        )
      }"
    >
      <p class="content-s-2-label">
        <label>Страны куда планируется экспорт продукции:</label>
      </p>
      <tags-input
        element-id="tags"
        v-model="selectedTags"
        :existing-tags="countryTags"
        :only-existing-tags="true"
        @tag-added="onTagAdded"
        @tag-removed="onTagRemoved"
        placeholder="Добавить страну"
        :typeahead="true"
        :disabled="$parent.$parent.projectDisabled"
      ></tags-input>
      <div class="error-text">
        {{
          $parent.$parent.checkErrorText(
            "PROJECTS",
            "LOGIC",
            "UF_EXPORT_COUNTRY_ID"
          )
        }}
      </div>
    </div>
    <p
      class="content-info-text"
      v-show="project.UF_IS_EXPORT_PRODUCT == '1'"
    ></p>
  </div>
</template>

<script>
import VoerroTagsInput from "@voerro/vue-tagsinput";
import Vue from "vue";
import { mapGetters } from "vuex";
import { FETCH_DIRECTORY } from "@/store/actions.type";

Vue.component("tags-input", VoerroTagsInput);
export default {
  name: "export_countries",
  data() {
    return {
      selectedTags: [],
      tagsLoaded: false
    };
  },
  created() {
    this.$store.dispatch(FETCH_DIRECTORY, ["country_export"]).then(() => {
      this.project.UF_EXPORT_COUNTRY_ID.forEach(function(cId) {
        this.directory.country_export.forEach(function(c) {
          if (cId === c.ID) {
            this.selectedTags.push(c.NAME);
          }
        }, this);
      }, this);
      this.tagsLoaded = true;
    }, this);
  },
  methods: {
    onTagAdded(slug) {
      if (slug > 0) {
        this.project.UF_EXPORT_COUNTRY_ID.push(
          this.directory.country_export[parseInt(slug)].ID
        );
        this.$parent.$parent.removeError(
          "PROJECTS",
          "LOGIC",
          "UF_EXPORT_COUNTRY_ID"
        );
      }
    },
    onTagRemoved(slug) {
      let rem = 0;
      this.directory.country_export.forEach(function(c) {
        if (c.NAME === slug) {
          rem = c.ID;
        }
      });
      if (rem > 0) {
        this.project.UF_EXPORT_COUNTRY_ID.forEach(function(c, index) {
          if (rem === c) {
            this.project.UF_EXPORT_COUNTRY_ID.splice(index, 1);
          }
        }, this);
      }
    }
  },
  computed: {
    countries() {
      let els = this.directory.country_export.filter(function(el) {
        for (let i = 0; i < this.project.UF_EXPORT_COUNTRY_ID.length; i++) {
          if (el.ID === this.project.UF_EXPORT_COUNTRY_ID[i]) {
            return true;
          }
        }
        return false;
      }, this);
      return els;
    },
    countryTags() {
      let countries = {};
      this.directory.country_export.forEach(function(el, k) {
        countries[k] = el.NAME;
      }, this);
      return countries;
    },
    tags() {
      let tags = {};
      this.directory.country_export.forEach(function(el, k) {
        tags[k] = el.NAME;
      }, this);
      return tags;
    },
    ...mapGetters(["directory", "project"])
  }
};
</script>

<style scoped></style>
